<template>
	<vue-scroll class="login-page align-vertical">
		<div class="form-wrapper align-vertical-middle">
			<div class="form-box card-base">
				<img class="image-logo" src="@/assets/images/logo.png" alt="logo"/>
				<float-label class="styled">
					<input id="login-email" type="email" placeholder="E-mail" v-model="form.email" @keyup.enter="login" required="required">
				</float-label>
				<float-label class="styled">
					<input id="login-password" type="password" placeholder="Password" v-model="form.password" @keyup.enter="login" required="required">
				</float-label>
				
				<div class="flex">
					<!-- <div class="box grow"><el-checkbox>Remember Me </el-checkbox></div> -->
					<div class="box grow text-right"><a href="#" @click="login">Login</a></div>
				</div>
			</div>
		</div>
	</vue-scroll>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
	name: 'Login',
	data() {
		return {
			form: {
				email: '',
				password: '',
			}
		}
	},
	methods: {
		login() {
			const email = document.getElementById('login-email')
			const pass = document.getElementById('login-password')

			if (email.checkValidity !== undefined && !email.checkValidity()) {
				return null
			}
			if (pass.checkValidity !== undefined && !pass.checkValidity()) {
				return null
			}

			debounce((async () => {
				const response = await fetch('https://api.reos.co.za/api/user/login', {
					method: 'POST',
					body: JSON.stringify(this.form),
					headers: {
						'content-type': 'application/json'
					}
				});

				if (!response.ok) {
					throw new Error('Login Error:', response.statusText);
				}

				this.$store.commit('setLogin', await response.json())
				this.$router.push('dashboard')
			}), 1000)()
		}
	}
}
</script>

<style lang="scss">
@import '../../../assets/scss/_variables';

.login-page {
	background: $background-color;
	margin-left: -30px;
	margin-right: -30px;

	.form-wrapper {
		width: 100%;
	}
	
	.form-box {
		width: 100%;
		max-width: 340px;
		padding: 30px;
		box-sizing: border-box;
		margin: 20px auto;

		a {
			font-size: 14px;
			color: $text-color-accent;
			text-decoration: none;
			font-weight: 500;
		}

		.image-logo {
			width: 120px;
			padding: 0;
			margin: 0px auto;
			display: block;
		}

		.login-btn ,
		.social-btn {
			width: 160px;

			&.google {
				margin-bottom: 10px;
				background-color: #d73d32;
				color: white;

				&:hover {
					border-color: #d73d32;
				}
			}
			&.facebook {
				background-color: #3f5c9a;
				color: white;

				&:hover {
					border-color: #3f5c9a;
				}
			}
		}

		.signin-box {
			font-size: 14px;
		}
	}
}

@media (max-width: 768px) {
	.layout-container .container .view.login-page {
		margin-left: -5px;
		margin-right: -5px;
		max-width: calc(100% + 10px);
	}
}
</style>



// WEBPACK FOOTER //
// src/views/pages/authentication/Login.vue